import http from './http'

export default {
  searchCategory(search) {
    return http.post('categories/find', {
      search,
    })
  },
}
